<template>
  <div tag-list>
    <a v-for="tag in tags" :key="tag" @click="$emit('input', tag)" :class="{on: value === tag}"><s>{{ tag }}</s></a>
  </div>
</template>

<script>
export default {
  name: 'TagList',
  props: ['tags', 'value'],
};
</script>

<style lang="less">
@import "~@/less/proj";
[tag-list] { .m(0,-4,-12,-4); .ib-list;
  a { .calibre; .fs(16); .lh(18); .medium; color:#555; .p(7,12); .br(2); .bgc(#ecedf1); .m(0,4,12);
    s { .cal-m; }
    &.on { .bgc(@c-blue); color:#fff; }
  }
}
</style>
